import { render, staticRenderFns } from "./ESayCarouselItem.vue?vue&type=template&id=3fb2e418&scoped=true&"
import script from "./ESayCarouselItem.vue?vue&type=script&lang=js&"
export * from "./ESayCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./ESayCarouselItem.vue?vue&type=style&index=0&id=3fb2e418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2e418",
  null
  
)

export default component.exports